import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Dónde puedo recibir SAINT® TMS?",
    answer:
      "SAINT® se administra en clínicas verificadas que cuentan con el sistema de neuromodulación Magnus. Neuro Wellness TMS Centers of America en Coral Springs, Florida, es un proveedor verificado de SAINT® en la Costa Este.",
  },
  {
    question: "¿Tengo que viajar para recibir SAINT®?",
    answer:
      "Depende de dónde viva. Algunos pacientes viajan desde otros estados. SAINT® se administra durante cinco días consecutivos, por lo que puede requerir desplazamiento y alojamiento si no reside cerca. Analizamos las opciones de viaje durante la consulta.",
  },
];

export const esWhereCanIGet = makeEsArticle({
  slug: "where-can-i-get-saint-tms",
  title: "¿Dónde puedo recibir SAINT® TMS?",
  description:
    "Dónde recibir SAINT® TMS: proveedores verificados, qué esperar si viaja desde fuera del estado, y cómo Neuro Wellness en Coral Springs, FL atiende a pacientes de todo el país.",
  h1: "¿Dónde puedo recibir SAINT® TMS?",
  breadcrumbLabel: "¿Dónde puedo recibir SAINT® TMS?",
  shortAnswer:
    "SAINT® se administra en clínicas verificadas que cuentan con el sistema de neuromodulación Magnus. Neuro Wellness TMS Centers of America en Coral Springs, Florida, es un proveedor verificado de SAINT® en la Costa Este. Algunos pacientes viajan desde otros estados; SAINT® se administra durante cinco días consecutivos y puede requerir desplazamiento y alojamiento si no reside cerca. Analizamos las opciones de viaje durante la consulta.",
  keyTakeaways: [
    "SAINT® se administra en clínicas verificadas con el sistema Magnus.",
    "Neuro Wellness en Coral Springs, FL es un proveedor verificado en la Costa Este.",
    "Algunos pacientes viajan desde otros estados para recibir SAINT®.",
    "SAINT® se administra durante cinco días consecutivos.",
    "Analizamos las opciones de viaje durante la consulta.",
  ],
  sections: [
    {
      heading: "Proveedores verificados de SAINT®",
      paragraphs: [
        "SAINT® se entrega en el sistema de neuromodulación Magnus, fabricado por Magnus Medical, Inc. Las clínicas que ofrecen SAINT® deben contar con este equipo y con personal formado en el protocolo.",
        "Neuro Wellness TMS Centers of America en Coral Springs, Florida, es un proveedor verificado de SAINT® en la Costa Este.",
      ],
    },
    {
      heading: "Viajar desde fuera del estado",
      paragraphs: [
        "SAINT® se administra durante cinco días consecutivos. Si no reside cerca de Coral Springs, puede que necesite desplazarse y alojarse durante la semana de tratamiento. Analizamos las opciones de viaje, incluidos los aeropuertos cercanos (FLL, PBI, MIA) y el alojamiento, durante la consulta.",
        "[[Viajar para SAINT®|/es/saint-tms-travel]] ofrece más información sobre cómo planificar su semana de tratamiento.",
      ],
    },
    {
      heading: "Cómo empezar",
      paragraphs: [
        "El primer paso es una consulta con nuestro equipo clínico para confirmar la elegibilidad. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
